import { render, staticRenderFns } from "./tmAudioResize.vue?vue&type=template&id=0bd5b59f&"
import script from "./tmAudioResize.vue?vue&type=script&lang=js&"
export * from "./tmAudioResize.vue?vue&type=script&lang=js&"
import style0 from "./tmAudioResize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports